<cyno-tabset customClass="tabset tabset--dark">
    <cyno-tab tabTitle="Wel verzekerd" [active]="true">
        <p>
            Schade aan uw woning en tuin voor alles dat vastzit en niet verwijderd kan worden zonder het te beschadigen,
            door bijvoorbeeld brand, storm, bliksem, water (zoals: regen of hagel), omvallen van bomen, afbreken van
            takken, diefstal, inbraak en vandalisme.
        </p>
        <p>
            U bent ook verzekerd voor schade aan bijgebouwen waar u de eigenaar van bent, wanneer deze niet verder dan
            500 meter van uw woning staan.
        </p>
        <div class="h4">Heeft u een schade die wij vergoeden?</div>
        <p>Dan bent u ook verzekerd voor extra (noodzakelijke) kosten:</p>
        <list-flat icon="check" [svg]="true">
            <list-flat-item>Om verdere schade te voorkomen of te beperken</list-flat-item>
            <list-flat-item>Om een boom op te ruimen na schade door storm</list-flat-item>
            <list-flat-item>Voor een tijdelijke vervangende woonruimte</list-flat-item>
            <list-flat-item>Om beschadigde onderdelen van uw woning af te voeren</list-flat-item>
            <list-flat-item>Om sloten binnen 24 uur na diefstal van uw huissleutels te vervangen</list-flat-item>
        </list-flat>
        <!-- prettier-ignore -->
        <p>
            Bovenstaande is een samenvatting van onze dekking. Hoe u precies bent verzekerd staat
            <ins-pdf-link [pdfLink]="documentsEnum.ConditionsHomeInsurance"
                          pdfLinkTitle="Voorwaarden Woonverzekering">in onze voorwaarden</ins-pdf-link>.
        </p>
    </cyno-tab>
    <cyno-tab tabTitle="Niet verzekerd">
        <p>Niet verzekerd is schade door:</p>
        <list-flat icon="dot" [svg]="true">
            <list-flat-item>Normaal gebruik (slijtage)</list-flat-item>
            <list-flat-item>Montage- of installatiefouten</list-flat-item>
            <list-flat-item>Een fout in het materiaal of de constructie van uw woning</list-flat-item>
            <list-flat-item>Onvoldoende of slecht onderhoud</list-flat-item>
            <list-flat-item>Openstaande ramen, deuren, lichtkoepels of luiken</list-flat-item>
            <list-flat-item>Het kraken van uw woning</list-flat-item>
            <list-flat-item>Verontreiniging van de bodem, lucht of het water</list-flat-item>
            <list-flat-item>Verzakking of verschuiven van de grond</list-flat-item>
        </list-flat>
        <p>
            <b>Niet verzekerd, maar wel aanvullend te verzekeren:</b>
            <br />
            Schade door uw eigen schuld of doordat u, iemand uit uw gezin of uw huisdier iets laat vallen of omstoot.
            Dit is wel verzekerd met onze Compleet-dekking.
        </p>
        <!-- prettier-ignore -->
        <p>
            Bovenstaande is een samenvatting van onze dekking. Hoe u precies bent verzekerd staat
            <ins-pdf-link [pdfLink]="documentsEnum.ConditionsHomeInsurance"
                          pdfLinkTitle="Voorwaarden Woonverzekering">in onze voorwaarden</ins-pdf-link>.
        </p>
    </cyno-tab>

    <cyno-tab tabTitle="Verzekerde bedragen">
        <p>Voor uw woning geldt geen maximaal verzekerd bedrag.</p>
        <p>
            In een aantal gevallen geldt een maximum vergoeding. Bijvoorbeeld € 25.000 voor schade aan uw tuin of uw
            bijgebouwen. Bij storm vergoeden wij per gebeurtenis maximaal € 1.000 aan opruimingskosten voor omgevallen
            bomen in uw tuin.
        </p>
        <p>
            Bovenstaande is een samenvatting van onze dekking. Hoe u precies bent verzekerd staat
            <ins-pdf-link [pdfLink]="documentsEnum.ConditionsHomeInsurance" pdfLinkTitle="Voorwaarden Woonverzekering">
                in onze voorwaarden
            </ins-pdf-link>
            .
        </p>
    </cyno-tab>

    <cyno-tab tabTitle="Eigen Risico">
        <p>
            Bij onze Inboedelverzekering is het eigen risico standaard €&nbsp;0. Maar in ruil voor een lagere premie
            kunt u kiezen voor een eigen risico van €&nbsp;150. Bij schade door storm is uw eigen risico €&nbsp;200.
        </p>
        <table class="table table--primary">
            <thead>
                <tr>
                    <th></th>
                    <th>Standaard eigen risico</th>
                    <th>Hoger eigen risico (met lagere premie)</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Eigen risico:</td>
                    <td class="table__center">€&nbsp;0</td>
                    <td class="table__center">€&nbsp;150</td>
                </tr>
                <tr>
                    <td>Eigen risico stormschade:</td>
                    <td class="table__center">€&nbsp;200</td>
                    <td class="table__center">€&nbsp;200</td>
                </tr>
            </tbody>
        </table>
    </cyno-tab>
</cyno-tabset>
